import { render, staticRenderFns } from "./semPermissao.vue?vue&type=template&id=6c90381a"
import script from "./semPermissao.vue?vue&type=script&lang=js"
export * from "./semPermissao.vue?vue&type=script&lang=js"
import style0 from "./semPermissao.vue?vue&type=style&index=0&id=6c90381a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports